import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Phone, Mail, MapPin, Instagram, Send } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormState('success');
    }, 1500);
  };
  return <Section id="contact" background="default" data-id="element-8">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-24" data-id="element-9">
        <div data-id="element-10">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c2c2c] mb-6" data-id="element-11">
            Ready to get started?
          </h2>
          <p className="text-lg text-[#525252] mb-10" data-id="element-12">
            Fill out the form or give us a call. We'll get back to you within 24
            hours to discuss your project.
          </p>

          <div className="space-y-8" data-id="element-13">
            <a href="tel:5036068823" className="flex items-start gap-4 group" data-id="element-14">
              <div className="w-12 h-12 rounded-full bg-[#ff6b35]/10 flex items-center justify-center text-[#ff6b35] group-hover:bg-[#ff6b35] group-hover:text-white transition-colors" data-id="element-15">
                <Phone className="h-6 w-6" data-id="element-16" />
              </div>
              <div data-id="element-17">
                <h3 className="font-bold text-[#2c2c2c] text-lg" data-id="element-18">Call Us</h3>
                <p className="text-[#525252]" data-id="element-19">(503) 606-8823</p>
                <p className="text-sm text-gray-400 mt-1" data-id="element-20">Mon-Fri, 8am - 6pm</p>
              </div>
            </a>

            <a href="mailto:fixandfinishpdx@gmail.com" className="flex items-start gap-4 group" data-id="element-21">
              <div className="w-12 h-12 rounded-full bg-[#ff6b35]/10 flex items-center justify-center text-[#ff6b35] group-hover:bg-[#ff6b35] group-hover:text-white transition-colors" data-id="element-22">
                <Mail className="h-6 w-6" data-id="element-23" />
              </div>
              <div data-id="element-24">
                <h3 className="font-bold text-[#2c2c2c] text-lg" data-id="element-25">Email Us</h3>
                <p className="text-[#525252]" data-id="element-26">fixandfinishpdx@gmail.com</p>
              </div>
            </a>

            <div className="flex items-start gap-4" data-id="element-27">
              <div className="w-12 h-12 rounded-full bg-[#ff6b35]/10 flex items-center justify-center text-[#ff6b35]" data-id="element-28">
                <MapPin className="h-6 w-6" data-id="element-29" />
              </div>
              <div data-id="element-30">
                <h3 className="font-bold text-[#2c2c2c] text-lg" data-id="element-31">
                  Service Area
                </h3>
                <p className="text-[#525252] mb-2" data-id="element-32">
                  Proudly serving the greater Portland Metro area and
                  surrounding communities throughout Oregon:
                </p>
                <p className="text-sm text-[#525252] leading-relaxed" data-id="element-33">
                  Portland, Beaverton, Tigard, Lake Oswego, Hillsboro, Gresham,
                  Milwaukie, Oregon City, West Linn, Tualatin, Wilsonville,
                  Sherwood, Clackamas, Happy Valley, Aloha, Troutdale, Wood
                  Village, Fairview, Damascus, Gladstone, and more.
                </p>
              </div>
            </div>

            <a href="https://instagram.com/fixandfinish_pdx" target="_blank" rel="noopener noreferrer" className="flex items-start gap-4 group" data-id="element-34">
              <div className="w-12 h-12 rounded-full bg-[#ff6b35]/10 flex items-center justify-center text-[#ff6b35] group-hover:bg-[#ff6b35] group-hover:text-white transition-colors" data-id="element-35">
                <Instagram className="h-6 w-6" data-id="element-36" />
              </div>
              <div data-id="element-37">
                <h3 className="font-bold text-[#2c2c2c] text-lg" data-id="element-38">Follow Us</h3>
                <p className="text-[#525252]" data-id="element-39">@fixandfinish_pdx</p>
              </div>
            </a>
          </div>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-40">
          {formState === 'success' ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-41">
              <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6" data-id="element-42">
                <Send className="h-8 w-8" data-id="element-43" />
              </div>
              <h3 className="text-2xl font-bold text-[#2c2c2c] mb-2" data-id="element-44">
                Message Sent!
              </h3>
              <p className="text-[#525252]" data-id="element-45">
                Thanks for reaching out. We'll be in touch shortly.
              </p>
              <Button variant="outline" className="mt-8" onClick={() => setFormState('idle')} data-id="element-46">
                Send another message
              </Button>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-47">
              <h3 className="text-2xl font-bold text-[#2c2c2c] mb-6" data-id="element-48">
                Send a Message
              </h3>

              <div className="grid sm:grid-cols-2 gap-6" data-id="element-49">
                <div className="space-y-2" data-id="element-50">
                  <label htmlFor="name" className="text-sm font-medium text-[#2c2c2c]" data-id="element-51">
                    Name
                  </label>
                  <input id="name" required type="text" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all" placeholder="John Doe" data-id="element-52" />
                </div>
                <div className="space-y-2" data-id="element-53">
                  <label htmlFor="phone" className="text-sm font-medium text-[#2c2c2c]" data-id="element-54">
                    Phone
                  </label>
                  <input id="phone" required type="tel" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all" placeholder="(503) 606-8823" data-id="element-55" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-56">
                <label htmlFor="email" className="text-sm font-medium text-[#2c2c2c]" data-id="element-57">
                  Email
                </label>
                <input id="email" required type="email" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all" placeholder="john@example.com" data-id="element-58" />
              </div>

              <div className="space-y-2" data-id="element-59">
                <label htmlFor="service" className="text-sm font-medium text-[#2c2c2c]" data-id="element-60">
                  Service Needed
                </label>
                <select id="service" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all bg-white" data-id="element-61">
                  <option data-id="element-62">General Repair</option>
                  <option data-id="element-63">Maintenance</option>
                  <option data-id="element-64">Small Remodel</option>
                  <option data-id="element-65">Emergency Service</option>
                  <option data-id="element-66">Other</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-67">
                <label htmlFor="message" className="text-sm font-medium text-[#2c2c2c]" data-id="element-68">
                  Message
                </label>
                <textarea id="message" required rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all resize-none" placeholder="Tell us about your project..." data-id="element-69"></textarea>
              </div>

              <Button type="submit" className="w-full" size="lg" isLoading={formState === 'submitting'} data-id="element-70">
                Send Message
              </Button>
            </form>}
        </div>
      </div>
    </Section>;
}